export const PageNotFound = () => (
  <div className="flex flex-col items-center justify-center opacity-70">
    <h1 className="text-8xl">404</h1>
    <h2 className="text-4xl">Page Not Found</h2>
  </div>
);
